import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';

export default function Pref() {
  const [hasPrefs, setHasPrefs] = useState(false);
  const [difficulty, setDifficulty] = useState('');
  const [showFirstLetter, setShowFirstLetter] = useState();
  const [mustStartWithLetter, setMustStartWithLetter] = useState();
  const [sounds, setSounds] = useState();
  
  const navigate = useNavigate ();
  const myUser = useAuth();

  // Load user prefs
  useEffect(() => {
    async function getUserPrefs() {
      fetch(process.env.REACT_APP_API_SERVER + '/api/user/'+ myUser.id +'/prefs', { 
        method: 'get', 
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
      })
      .then(response => response.json())
      .then(data => checkPrefs(data));
      return;
    }
    getUserPrefs();
  }, []);

  // Set user prefs
  const checkPrefs = (prefs) => {
    if (prefs.difficulty !== 'not_found') {
      setDifficulty(prefs.difficulty);
      setShowFirstLetter(prefs.show_first_letter);
      setMustStartWithLetter(prefs.must_start_with_letter);
      setSounds(prefs.sounds);
      setHasPrefs(true);
    }
  }

  // Validate
  function handleSubmit(e) {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Get the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = JSON.stringify(Object.fromEntries(formData.entries()));

    // Send to API
    savePrefs(formJson);
  }

  // Save prefs in DB
  async function savePrefs(data) {
    fetch(process.env.REACT_APP_API_SERVER + '/api/user/'+ myUser.id +'/prefs', { 
      method: hasPrefs ? 'put' : 'post', 
      headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token},
      body: data 
    })
    .then(response => response.json())
    .then(data => confirmation(data));
    return;
  }

  // Display confirmation message
  const confirmation = (data) => {
    if (data.status === 'success') {
      toast.success('Succès ! 🎉', {
        autoClose: 500,
        onClose: () => navigate('/'),
      });
      console.log("Modifications sauvegardées");
    }
    else {
      toast.error('Erreur 😱');
      console.log("Erreur de sauvegarde");
    }
  }

  // update shiwFirstLetter
  const updateShowFirstLetter = (val) => {
    setShowFirstLetter(val);

    // if not show first letter -> can change first letter
    if (val == 0) setMustStartWithLetter(val);
  }

  // update showFirstLetter
  const updateMustStartWithLetter = (val) => {
    if (showFirstLetter == 0) {
      setMustStartWithLetter(0);
      toast.success('Il faut pour cela afficher la 1ère lettre ci-dessus', {
        autoClose: 4000,
      });
    }
    else setMustStartWithLetter(val);
  }
  
  return (
    <div>
        <h1>Préférences</h1>

        <form method="post" onSubmit={handleSubmit}>
          <p>
            <label>
              Difficulté :&nbsp;
            <select name="difficulty" value={difficulty} onChange={e => setDifficulty(e.target.value)}>
              <optgroup label="Longueurs différentes">
                <option value="child">Facile (4 à 5 lettres)</option>
                <option value="padawan">Intermédiaire (6 à 8 lettres)</option>
                <option value="jedi">Avancé (8 à 10 lettres)</option>
                {/*<option value="yoda">Pro (8 à 12 lettres)</option>*/}
                <option value="jarjar">Complet (5 à 10 lettres)</option>
              </optgroup>
              <optgroup label="Longueur fixe">
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </optgroup>
            </select>
            </label>
          </p>

          <p>Afficher la 1ère lettre du mot : &nbsp;
            <select name="show_first_letter" defaultValue={1} value={showFirstLetter} onChange={e => updateShowFirstLetter(e.target.value)}>
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </p>

          <p>Le mot proposé doit commencer par la 1ère lettre affichée : &nbsp;
            <select name="must_start_with_letter" defaultValue={1} value={mustStartWithLetter} onChange={e => updateMustStartWithLetter(e.target.value)}>
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </p>
          
          <p>Sons du jeu : &nbsp;
            <select name="sounds" defaultValue={0} value={sounds} onChange={e => setSounds(e.target.value)}>
              <option value="0">Non</option>
              <option value="1">Oui</option>
            </select>
          </p>
          <hr />
          
          <button type="submit">Enregistrer</button>
        </form>
    </div>
  );
}